<template>
  <div class="job-list">
    <div class="job-list__controls">
      <b-img
        @click.prevent="next()"
        :src="require('@/assets/icons/arrow-right.svg')"
        :class="[
          'pointer',
          {
            disabled: loading || slides.length <= 1
          }
        ]"
      ></b-img>
      <b-img
        @click.prevent="prev()"
        :src="require('@/assets/icons/arrow-left.svg')"
        :class="[
          'mr-4 pointer',
          {
            disabled: loading || slides.length <= 1
          }
        ]"
      ></b-img>
    </div>
    <div v-if="loading" class="job-list__slider">
      <b-row>
        <b-col v-for="i in 4" :key="i">
          <card-shimmer></card-shimmer>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="text-center pt-3" v-if="recentViewedJobs.length === 0">
        <h5>Oops!</h5>
        <p>
          You haven't viewed any tools yet.
          <br />Try refreshing or come back again next time!
        </p>
      </div>
      <div v-if="recentViewedJobs.length !== 0">
        <b-carousel
          ref="carousel"
          v-model="slide"
          pause="hover"
          class="overflow-hidden"
          :interval="0"
        >
          <b-carousel-slide
            class="job-list__slider"
            v-for="(slide, index) in slides"
            :key="index"
          >
            <template v-slot:img>
              <b-row no-gutter>
                <b-col md="3" class="d-flex" v-for="job in slide" :key="job.id">
                  <job-item :job="job" />
                </b-col>
              </b-row>
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Carousel list of recently viewed Jobs
 * ==================================================================================
 **/

import { mapState, mapActions, mapMutations } from 'vuex'
import JobItem from '@/components/cards/JobItem'
import CardShimmer from '@/components/shimmers/card'

export default {
  components: {
    JobItem,
    CardShimmer
  },

  computed: {
    ...mapState({
      recentViewedJobs: state => state.job.recentViewedJobsList,
      recentViewedJobsMeta: state => state.job.recentViewedJobsListMeta
    }),

    slides() {
      let result = []
      let rowLimit = 4
      for (
        var i = 0, length = this.recentViewedJobs.length;
        i < length;
        i += rowLimit
      ) {
        result.push(this.recentViewedJobs.slice(i, i + rowLimit))
      }
      return result
    }
  },

  data: function() {
    return {
      loading: false,
      slide: 0,
      limit: 8,
      filters: {
        search: null,
        suburb: null,
        within_distance_to: null
      }
    }
  },

  methods: {
    ...mapActions({
      getJobs: 'job/getJobs'
    }),

    ...mapMutations({
      clearJobs: 'job/clearJobList'
    }),

    next() {
      if (!this.loading) {
        this.$refs.carousel.next()
      }
    },

    prev() {
      if (!this.loading) {
        this.$refs.carousel.prev()
      }
    },

    async fetchJobs(page = 1) {
      if (this.loading) return

      const params = {
        page: page,
        limit: this.limit,
        recently_viewed: true,
        filters: this.filters
      }

      this.loading = true
      await this.getJobs(params)
      this.loading = false
    }
  },

  created() {
    this.clearJobs('recentViewedJobsList')
    this.fetchJobs()
  }
}
</script>
